import axios from 'axios';
let api = null;

function create() {  
  api = axios.create({
    baseURL: process.env.REACT_APP_API_URL ?? 'http://localhost:8080',
    withCredentials: true,
  });
  
  api.interceptors.request.use((config) => {
    if (config.headers && !config.headers['Content-Type']) {
      config.headers['Content-Type'] = 'application/json';
    }
    return config;
  });

  api.interceptors.response.use(
    (response) => {
      return response;
    },
    (error) => {
      if (error.response.status === 401 && error.config.url !== '/login') {
        console.error('Unauthorized access - redirecting to login');
        window.location.href = '/login';
      }
      return Promise.reject(error);
    }
  );

  return api;
}

export function createAPI() {
  if (!api) {
    create();
  }
  return api;
}
